<template>
  <input type="text" :value="modelValue" :placeholder="placeholder" @input="onInput" />
  <p v-if="errorMessage" class="small error-comment">
    {{ errorMessage }}
  </p>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { debounce } from 'lodash';

import { validateName } from '@/utils/validators';

const modelValue = defineModel<string>('modelValue', { default: '' });
const props = withDefaults(
  defineProps<{
    placeholder?: string;
  }>(),
  {
    placeholder: '',
  }
);
const { t } = useI18n();

const errorMessage = ref<string>('');

const validateInput = () => {
  const inputError = validateName(modelValue.value);
  if (inputError) {
    errorMessage.value = t(inputError);
  } else {
    errorMessage.value = '';
  }
};

const debounceValidateInput = debounce(validateInput, 300);

const onInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  modelValue.value = target.value;
  debounceValidateInput();
};
</script>

<style scoped lang="scss">
.error-comment {
  padding: 0.5rem 0.75rem;
  background: $error-bg;
  color: $new-warning;
  margin-top: 5px;
  border-radius: 8px;
}
</style>
